



















import { Component, Vue } from 'vue-property-decorator';
import { UserNotification } from '@/classes/UserNotification';
import _ from 'underscore';

@Component
export default class Home extends Vue {
    public get userNotifications(): UserNotification[] {
        const userNotifications: UserNotification[] = this.$store.getters['notifications/getViewableUserNotifications'] || [];
        return _.sortBy(userNotifications, (u) => u.publishDateTime);
    }
}
